import { render } from "./CompanyInfo.vue?vue&type=template&id=50a5a3d7&scoped=true&ts=true"
import script from "./CompanyInfo.vue?vue&type=script&lang=ts"
export * from "./CompanyInfo.vue?vue&type=script&lang=ts"

import "./CompanyInfo.vue?vue&type=style&index=0&id=50a5a3d7&lang=scss&scoped=true"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a5a3d7"]])

export default __exports__